import React, { useEffect, useState } from 'react'
import LoadingData from '../../../../components/ui/LoadingData'
import ProtectedRoute from '../../../../middleware/ProtectedRoute'
import LayoutProgramDetail from '../../../../components/pages/Member/Program/LayoutProgramDetail'
import { getRecordedProgram } from '../../../../services/userPrograms'
import { getTutorSchedule } from '../../../../services/tutor'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getDetailProgramMember } from '../../../../store/detailProgram'


const DetailProgram = () => {
  const { isLoadingProgram } = useSelector(state => state.detail_program)
  const dispatch = useDispatch()
  const params = useParams()
  const programId = params.id
  const [tutorProgram, setTutorProgram] = useState([])
  const [recordingProgram, setRecordingProgram] = useState([])
  const [loading, setLoading] = useState(true)

  const handleGetDetailprogram = async () => {
    setLoading(true)
    try {
      const response = await dispatch(getDetailProgramMember(programId)).unwrap()
      const getTutorProgram = await handleGetTutorProgram(response?.eventSchedule?.id, response?.eventSchedule?.event?.id)
      setTutorProgram(getTutorProgram)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleGetRecordingProgram = async (programId) => {
    try {
      const response = await getRecordedProgram(programId)
      setRecordingProgram(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetTutorProgram = async (scheduleId, eventId) => {
    try {
      const response = await getTutorSchedule(scheduleId, eventId)
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetDetailprogram()
    handleGetRecordingProgram(programId)
    // eslint-disable-next-line
  }, [programId])

  return (
    <ProtectedRoute>
      {isLoadingProgram || loading ? (<LoadingData />) : (<LayoutProgramDetail videoProgram={recordingProgram} tutor={tutorProgram} handleReload={handleGetDetailprogram} />)}
    </ProtectedRoute>
  )
}

export default DetailProgram